import React from 'react';
import ScrollProgressBar from './ScrollProgressBar';
import BackButton from './BackButton';
import HomeButton from './HomeButton';
import PageCTA from './PageCTA';
import './ListPage.css';

// Shared skeleton for a simple "title + intro + list of cards + CTA" page —
// Work and SideProjects used to each hand-roll this exact structure (and
// its CSS) independently, differing only in the title/intro text, the data
// source, how each item renders, and the CTA's own label/target.
const ListPage = ({ title, intro, items, renderItem, cta }) => (
  <>
  <ScrollProgressBar />
  <BackButton />
  <HomeButton />
  <div className="list-page">
    <div className="page-container one-col-layout">
      <div className="page-header">
        <h1>{title}</h1>
        <p className="page-intro">{intro}</p>
      </div>

      <div className="list-page-items scroll-fade">
        {items.map(renderItem)}
      </div>

      <PageCTA {...cta} className="list-page-cta" />
    </div>
  </div>
  </>
);

export default ListPage;
